(function () {
  var containers = document.querySelectorAll('[data-key-benefits]');
  if (!containers.length) return;

  containers.forEach(function (container) {
    var items = container.querySelectorAll('[data-key-benefits-item]');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  });
})();
